import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

export default function CollapsibleHeader({ title, isOpen, onToggle }) {
    return (
        <div className="collapsible-header" onClick={onToggle}>
            <h3>{title}</h3>
            <FontAwesomeIcon 
                icon={isOpen ? faChevronUp : faChevronDown} 
                className={`arrow-icon ${isOpen ? 'open' : ''}`}
            />
        </div>
    );
}